import { useEffect, useRef } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL || "";

export default function LiveLocationHeartbeat({ isClockedOn, visitId, shiftId }) {
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!isClockedOn) return;
    if (!navigator.geolocation) return;

    const sendLocation = () => {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          try {
            if (pos.coords.accuracy && pos.coords.accuracy > 500) {
              console.warn("Live location skipped: poor GPS accuracy", pos.coords.accuracy);
              return;
            }

            const token = localStorage.getItem("token");

            await axios.post(
              `${API}/api/live-location/heartbeat`,
              {
                visit_id: visitId,
                shift_id: shiftId,
                latitude: pos.coords.latitude,
                longitude: pos.coords.longitude,
                accuracy: pos.coords.accuracy,
                recorded_at: new Date().toISOString(),
              },
              {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
              }
            );
          } catch (err) {
            console.warn("Live location heartbeat failed", err?.response?.data || err.message || err);
          }
        },
        (err) => {
          console.warn("Live location permission/error", err);
        },
        {
          enableHighAccuracy: true,
          maximumAge: 15000,
          timeout: 10000,
        }
      );
    };

    sendLocation();
    intervalRef.current = setInterval(sendLocation, 30000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isClockedOn, visitId, shiftId]);

  return null;
}
